/**
 * frontend/src/pages/valuation/_ActionChip.tsx
 *
 * VAL-HISTORY-ICONS-1 — the icon-only action chip, shared by the Dashboard
 * and the History table (_EngagementTable). Moved out of ValuationDashboard
 * unchanged. VAL-PATH-ROUTES (P1): the colour comes from nextStep().kind and
 * the words are "Next: <step label>", the same label the left nav marks.
 */
import { Link } from 'react-router-dom'
import { ClipboardList, Eye, PenLine } from 'lucide-react'
import type { ChipKind } from './_nextStep'

export type { ChipKind }
const CHIP_COLOR: Record<ChipKind, string> = {
  sign: 'border-green-700 bg-green-600 text-white hover:bg-green-500',
  intake: 'border-amber-700 bg-amber-500 text-white hover:bg-amber-400',
  view: 'border-gray-400 bg-gray-100 text-gray-700 hover:bg-gray-200',
}
const CHIP_ICON = { sign: PenLine, intake: ClipboardList, view: Eye } as const

/** Icon-only action. The words live in aria-label and a CSS tooltip (hover and
 *  keyboard focus), so the chip has no text node. */
export function ActionChip({ label, route, kind, raised }: { label: string; route: string; kind: ChipKind; raised: boolean }) {
  const words = kind === 'view' ? label : `Next: ${label}`
  const Icon = CHIP_ICON[kind]
  return (
    <Link
      to={route}
      aria-label={words}
      data-tip={words}
      data-raised={raised ? 'true' : 'false'}
      className={`relative inline-flex h-9 w-9 items-center justify-center rounded-md border ${raised ? 'border-b-4' : 'border-b'} ${CHIP_COLOR[kind]} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-gray-500 after:pointer-events-none after:absolute after:bottom-full after:right-0 after:mb-1 after:hidden after:whitespace-nowrap after:rounded after:bg-gray-900 after:px-2 after:py-1 after:text-xs after:text-white after:content-[attr(data-tip)] hover:after:block focus-visible:after:block`}
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
    </Link>
  )
}
